import { Box } from "@mui/material";
import img from "./miniorange-logo.png";
import bg from "./bg-image.jpg";
import React, { useEffect, useState } from "react";
import { redirect, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import GoogleLogo from "./google-svg";

function Login() {
  const navigate = useNavigate();

  const [loginInputFields, setLoginInputFields] = useState({
    email: "",
    password: "",
  });

  const [error, setError] = useState({ email: false, password: false });

  async function googleSignIn() {
    await axios
      .get(`${process.env.REACT_APP_BASE_URL}/google-sign-in-redirect-url?source=${encodeURIComponent(window.location.href)}`)
      .then((response) => {
        if (response.data.status) {
          window.location.href = response.data.url;
        }
      })
      .catch((err) => {
        console.log(err);
        swal({
          text: "Something Went Wrong",
          icon: "error",
        });
      });
  }

  const onChange = (event) => {
    const { name, value } = event.target;

    setError((prevValue) => {
      return {
        ...prevValue,
        [name]: false,
      };
    });

    setLoginInputFields((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  function redirectUserRegister(){
    var source = window.location.href.split('source=')[1]
    window.location.href ='/register?source=' + source;
  }
  const login = () => {
    // setLoadingScreenTime(true);
    if (!loginInputFields.email && !loginInputFields.password) {
      setError({
        email: true,
        password: true,
      });
      return;
    } else if (!loginInputFields.email) {
      setError({
        email: true,
        password: false,
      });
      return;
    } else if (!loginInputFields.password) {
      setError({ email: false, password: true });
      return;
    }
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/login`, {
        email: loginInputFields.email,
        password: loginInputFields.password
      })
      .then((res) => {
        localStorage.setItem("token", res.data.token);
        // setLoadingScreenTime(false);
        navigate("/token-gating");
      })
      .catch((err) => {
        if (
          err.response &&
          err.response.data &&
          err.response.data.errorMessage
        ) {
          // setLoadingScreenTime(false);
          swal({
            text: err.response.data.errorMessage,
            icon: "error",
          });
        }
      });
  };

  useEffect(() => {});
  return (
    <>
      <Box
        sx={{
          display: "block",
        }}
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Box sx={{ width: "350px", margin: "50px 0px 50px 42px" }}>
            <img src={img} style={{ width: "250px", marginLeft: "-11px" }} />
            <h2 className="login-text">Log in into your account</h2>
            <span className="login-subtitle">
              Don't have an account?
              <a
                style={{ textDecoration: "none", color: "rgb(1, 107, 248)" }}
                onClick={redirectUserRegister}
              >
                &nbsp;Sign up
              </a>
            </span>
            <button
              onClick={googleSignIn}
              type="button"
              className="login-with-google-btn"
            >
              <GoogleLogo />
              <span className="google-text">Google</span>
            </button>
            <div className="or-box">
              <span className="or-text">Or with email and password</span>
            </div>
            <fieldset className="login-form">
              <label
                htmlFor="email"
                id="usernameLabel"
                className="login-form-label"
              >
                Email address
                <div className="input-div-css-1  input-div-css-2">
                  <div className="input-div-css-3">
                    <input
                      name="email"
                      // autocomplete="email"
                      aria-labelledby="usernameLabel"
                      type="email"
                      className="input-custom-css"
                      required
                      id="email"
                      aria-invalid="false"
                      value={loginInputFields.email}
                      onChange={onChange}
                    ></input>
                  </div>
                </div>
              </label>
              {error.email && (
                <span className="error-message">Please provide email</span>
              )}
            </fieldset>
            <fieldset className="login-form">
              <label
                htmlFor="password"
                id="passwordLabel"
                className="login-form-label"
              >
                Password
                <div className="input-div-css-1  input-div-css-2">
                  <div className="input-div-css-3">
                    <input
                      name="password"
                      aria-labelledby="passwordLabel"
                      type="password"
                      className="input-custom-css"
                      required
                      id="password"
                      aria-invalid="false"
                      value={loginInputFields.password}
                      onChange={onChange}
                    ></input>
                  </div>
                </div>
              </label>
              {error.password && (
                <span className="error-message">Please provide password</span>
              )}
            </fieldset>
            <div className="login-button-div">
              <button onClick={login} className="custom-button">
                Login
              </button>
            </div>
            <div className="footer-div">
              <a
                href="https://www.miniorange.com/usecases/miniOrange_Privacy_Policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="privacy-policy"
              >
                Privacy Policy
              </a>
              <a
                href="https://www.miniorange.com/usecases/miniOrange_User_Agreement.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="terms-of-services"
              >
                Terms of Services
              </a>
            </div>
          </Box>
          <Box
            sx={{
              bgcolor: "white",
              width: "calc(100vw - 350px)",
              backgroundImage: "url(" + bg + ")",
              objectFit: "contain",
              backgroundSize: "cover",
            }}
          >
            <div className="cover-box">
              <h2 className="cover-h2">miniOrange DApp</h2>
              <h3 className="cover-h3">
                Get started now with NFT Token Gating your website, domains, and
                applications today with the power of Web 3.0 and the
                decentralized system to provide the best token-gated experience
                to all your customers and site visitors.
              </h3>
            </div>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default Login;
